import { render, staticRenderFns } from "./ContentList.vue?vue&type=template&id=dc04c894&scoped=true"
import script from "./ContentList.ts?vue&type=script&lang=ts&external"
export * from "./ContentList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc04c894",
  null
  
)

export default component.exports